import { IExtensionsServerSettings } from '../types/IEditableServerSettings';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ISetRunNowForSitesParams {
  sites: string[];
  shouldEnable: boolean;
}

export type ISetRunNowForSitesResult = IResult & IExtensionsServerSettings;

export class SetRunNowForSitesRequest extends Request<ISetRunNowForSitesParams, ISetRunNowForSitesResult> {
  constructor(params: ISetRunNowForSitesParams) {
    super('setRunNowForSites', params);
  }
}
